import React from 'react';
import { addNewPositionToUrl } from '../../../../decision/decisionUtils';
import { DecisionKeywords } from '../../../../decision/keywords/DecisionKeywords';
import { AddToFolderAddButton } from '../../../../folders/dropdown/button/AddToFolderAddButton';
import { FolderItem } from '../../../../folders/list/FolderItem';
import { FolderList } from '../../../../folders/list/FolderList';
import { getKeywords } from '../../../search-utils';
import { HitCommentariesList } from '../hit-commentaries/HitCommentariesList';
import { DecisionSearchHeader } from './DecisionSearchHeader';
import { SearchDecision } from '../../../../decision/decision.types';
import { Folder } from '../../../../folders/folders.types';
import { FeedbackBox } from '../feedback-box/FeedbackBox';
import styles from './search_result_decision.module.scss';
import { ItemSeparator } from '../../../../components/item-separator/ItemSeparator';
import { ScrollToMe } from '../../../../components/ScrollToMe';
import { getCommentariesUrls } from '../commentaries-modal/decisionApi';
import { Connect, PropsFromRedux } from './SearchResultDecisionContainer';
import { withUser } from '../../../../user/UserContext';
import { UserContextType } from '../../../../user/user.types';
import { withFolderDropdown } from '../../../../folders/dropdown/FoldersDropdownContext';
import { SearchDecisionFoldersDropdown } from './SearchDecisionFoldersDropdown';
import {
  ExcerptContainer,
  ExcerptActionBar,
} from '../../../../components/excerpt/Excerpt';
import { OutsideFocusHandler } from '../../../../components/dropdown/outside-handler/OutsideFocusHandler';
import { FoldersDropdownContextType } from '../../../../folders/dropdown/foldersDropdown.types';
import { ExcerptSummary } from '../../../../components/excerpt/summary/ExcerptSummary';

type Props = {
  decision: SearchDecision;
  index: number;
  shouldScroll: boolean;
  isLast: boolean;
} & PropsFromRedux &
  UserContextType &
  FoldersDropdownContextType;

const onDecisionClicked = (decision: SearchDecision) => () => {
  if (decision.position != null) {
    addNewPositionToUrl(decision.position);
  }
};

export class RawSearchResultDecision extends React.Component<Props> {
  shouldComponentUpdate(prevProps: Props) {
    const {
      decision: { docId },
    } = this.props;
    return prevProps.decision.docId !== docId;
  }

  render() {
    const {
      decision,
      index,
      shouldScroll,
      type,
      isLast,
      loggedIn,
      closeDropdown,
    } = this.props;
    const keywords = getKeywords(decision);
    const isLastRestricted = !loggedIn && isLast;
    return (
      <ScrollToMe shouldScroll={shouldScroll} offset={-120}>
        {ref => (
          <ExcerptContainer
            classNames={isLastRestricted ? styles.gradient : ''}
            ref={ref}
          >
            <ItemSeparator />
            {debugScore(decision.score)}
            <DecisionSearchHeader
              index={index}
              decision={decision}
              source="excerpt_results"
            />
            <DecisionKeywords keywords={keywords} />
            <ExcerptSummary
              hit={{
                visited: decision.visited,
                url: decision.url,
                summary: decision.sommaireAna,
              }}
              source="excerpt_results"
              onHitClicked={onDecisionClicked(decision)}
            />
            <HitCommentariesList
              commentaries={decision.comments || []}
              docId={decision.docId}
              numberOfComments={decision.numberOfComments}
              nextCommentAuthors={decision.nextCommentAuthors}
              otherCommentAuthorsCount={decision.otherCommentAuthorsCount}
              source="decision-results"
              allCommentariesGetter={getCommentariesUrls}
              searchType={type}
            />
            {!isLastRestricted && (
              <ExcerptActionBar>
                <OutsideFocusHandler
                  onOutsideClick={closeDropdown}
                  className={styles.wrapper}
                >
                  <AddToFolderAddButton />
                  <SearchDecisionFoldersDropdown docId={decision.docId} />
                </OutsideFocusHandler>
                <FolderList docId={decision.docId}>
                  {(folder: Folder) => (
                    <FolderItem
                      source="search-decision-folders"
                      folder={folder}
                      docId={decision.docId}
                    />
                  )}
                </FolderList>
              </ExcerptActionBar>
            )}
            {index === 9 && (
              <div className={styles.feedback}>
                <FeedbackBox />
              </div>
            )}
          </ExcerptContainer>
        )}
      </ScrollToMe>
    );
  }
}

function debugScore(score: number | null) {
  return score && <span>{score}</span>;
}

export const SearchResultDecision = Connect(
  withUser(withFolderDropdown(RawSearchResultDecision)),
);
